import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
    Alert,
    CircularProgress,
    Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function DeleteEventDialog({ open, onClose, event, onConfirm }) {
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    if (!event) return null;

    const handleClose = (evt, reason) => {
        if (reason === 'backdropClick') return;
        if (submitting) return;
        setError(null);
        onClose?.(evt, reason);
    };

    const handleConfirm = async () => {
        setError(null);
        setSubmitting(true);
        try {
            await onConfirm?.(event.id);
            // quem fecha é a page (depois de sucesso) — mas pode fechar aqui também
        } catch (err) {
            const msg =
                err?.response?.data?.message ||
                err?.response?.data ||
                'Erro ao excluir evento.';
            setError(typeof msg === 'string' ? msg : 'Erro ao excluir evento.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
            <DialogTitle>
                Confirmar exclusão
                <IconButton
                    aria-label='close'
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (t) => t.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <Alert severity='warning'>
                        Esta ação é <strong>irreversível</strong>. O evento será
                        removido permanentemente.
                    </Alert>

                    <Typography variant='body2' sx={{ color: '#555' }}>
                        Tem certeza que deseja excluir o evento?
                    </Typography>

                    {error && <Alert severity='error'>{error}</Alert>}
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                    variant='outlined'
                    disabled={submitting}
                >
                    Cancelar
                </Button>

                <Button
                    onClick={handleConfirm}
                    variant='contained'
                    color='error'
                    disabled={submitting}
                    startIcon={
                        submitting ? (
                            <CircularProgress size={18} />
                        ) : (
                            <DeleteOutlineIcon />
                        )
                    }
                >
                    {submitting ? 'Excluindo...' : 'Excluir'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
